'use strict'

import Axios  from 'axios'
import Config from '../../configuration.js'

/**
 * http://localhost/Specif/EUDO_07676/root/SectionORM/commune/liste
 */

var capitalizeFirstLetter = function(string) {
  string = string.toLowerCase()
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var chargerCommunes = function(){
    
  return new Promise(function(Resolve){
    Axios.get(Config.url.service + '/commune/liste?emploi=1') // retrouve uniquement les communes liéés à des offres d'emplois
    .then(function(Reponse){
      Reponse.data.items.sort((a, b) => a.libelle.trim().localeCompare(b.libelle.trim()))  // Tri des valeurs par le libellé
      Resolve(Reponse.data.items)
    })
  })
}

var construcFormData = function(Cntxt){
  
  var form_data = new FormData()
  var filtrePost = ""
  var filtreName =""

  // Filtres combos
  var filtreList = ['filtreSecteurActivite', 'filtreTypeContrat', 'filtreCommune'];
  for(var i=0; i<filtreList.length;i++){
    filtrePost = ""
    filtreName = filtreList[i]

    for(var j=0;j<Cntxt.getters[filtreName].length;j++){
      if(filtrePost){
        filtrePost += ";"
      }
      filtrePost += Cntxt.getters[filtreName][j].id
    }

    if (filtrePost.length > 0){
      form_data.append(filtreName, filtrePost)
    }
  }


  //form_data.append('id',                    Cntxt.getters['id'])
  form_data.append('id',                    Cntxt.getters['idCrypte'])


  return form_data
  
}


export default {
  namespaced: true,

  /**
   * STATE
   */
  state: {
    idCrypte        : "", // Id de l'offre demandé lors de l'affichage de la fiche
    fiche     : { id: 0 }, // Offre de la fiche
    items     : [], // Offres immo
    communes  : [], // Liste des communes déduites de la liste des offres
    panelState: 0,  // Panneau filtre de la liste immo ouvert ou fermé
    filtre    : {
      commune          : [],
      typeContrat    : [],
      secteurActivite           : [],
    },
  },

  /**
   * MUTATIONS
   */
  mutations: {

    

    /**
     * Actualise l'Id crypté de l'offre demandé
     */
    idCrypte(State, IdCrypte){
      State.idCrypte = IdCrypte
    },

    /**
     * Actualise l'offre immo actuellement consulté
     */
    fiche(State, Fiche){
      State.fiche = Fiche
    },

    /**
     * Actualise la liste des offres immos
     */
    items(State, Items){
      State.items = Items
    },

    /**
     * Change l'état du panneau de filtre
     */
    panelState(State, Value){
      State.panelState = Value
    },

    /**
     * Actualise la liste des communes
     */
    communes(State,  Items){
      State.communes = Items
    },

    /**
     * Change le filtre commune
     */
    filtreCommune(State, Value){
      State.filtre.commune = Value
    },


    /**
     * Change le filtre transaction
     */
    filtreSecteurActivite(State, Value){
      State.filtre.secteurActivite = Value
    },

    /**
     * Change le filtre type
     */
    filtreTypeContrat(State, Value){
      State.filtre.typeContrat = Value
    },

    
  },

  /**
   * GETTERS
   */
  getters: {
    
    /**
     * Retourne l'id de l'offre demandé
     */
    idCrypte(State){
      return State.idCrypte
    },

    /**
     * Retourne l'offre chargé
     */
    fiche(State){
      return State.fiche
    },

    /**
     * Retourne la liste des offres
     */
    items(State){
      return State.items
    },

    /**
     * Change l'état du panneau de filtre
     */
    panelState(State){
      return State.panelState
    },

    /**
     * Actualise la liste des communes
     */
    communes(State){
      return State.communes
    },

    /**
     * Change le filtre commune
     */
    filtreCommune(State){
      return State.filtre.commune
    },

    /**
     * Change le filtre transaction
     */
     filtreSecteurActivite(State){
      return State.filtre.secteurActivite
    },

    /**
     * Change le filtre type
     */
     filtreTypeContrat(State){
      return State.filtre.typeContrat
    },


  },
  /**
   * ACTIONS
   */
  actions: {
    
    /**
     *
     */
     liste(Context){

      var form_data = construcFormData(Context)

      return Axios.post(Config.url.service + '/offreemploi/liste', form_data) // Contacte l'orm pour récupérer les données
      .then(function(Reponse){
        // Traite les offres immos
        Reponse.data.items.sort((a, b) => a.libelle.trim().localeCompare(b.libelle.trim())) // Tri des valeurs par le libellé

        var items = Reponse.data.items

        for(var i=0; i<items.length;i++){
          items[i].libelle = capitalizeFirstLetter(items[i].libelle)
          items[i].ville = capitalizeFirstLetter(items[i].ville)
        }

        Context.commit('items' , items)
        Promise.resolve();
      })
    },

    /**
     * Charge une seule fiche
     */
    async fiche(Context, IdCrypte){
      
      if(Context.getters['items'].length < 1){
        await Context.dispatch('liste')
      }

      Context.commit('idCrypte' , IdCrypte)
      Context.dispatch('renvoyerItem')
    },

    renvoyerItem(Context){
      for(var i=0;i<Context.getters['items'].length;i++){
        
        if (decodeURI(Context.getters['items'][i].idCrypte) == Context.getters['idCrypte']){
          var offre = Context.getters['items'][i]
         
         
          
          Context.commit('fiche' , offre)
        }
      }
    },

    /**
     * Charge les communes
     */
    async listeCommune(Context){

      var items = await chargerCommunes() // Requete Ajax

      Context.commit('communes',  items)
    },

  }, //ACTIONS
}

